import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Select } from '@/ui';

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.LIGHTEST_GRAY};
      padding: 1rem 0.5rem;
      font-weight: normal;
    }
    th:last-child {
      border-right: none;
    }
  }
`;

export const StyledFilterSelect = styled(Select)`
  &&& {
    min-height: 40px;

    .ant-select-selection-placeholder {
      color: ${COLORS.BLACK};
    }

    .ant-select-selector {
      overflow: hidden;
      padding-top: 0.15rem;
    }
  }
`;
